exports["NO"] = require("./NO.js");
exports["UK"] = require("./UK.js");
exports["IS"] = require("./IS.js");
exports["TR"] = require("./TR.js");
exports["AZ"] = require("./AZ.js");